import React from 'react';
import _ from 'lodash';
import { IconButton } from '../IconButton';

export function TableWithSelection({ 
  children, 
  className = '', 
  additiveSelection = false,
  selected = [], 
  onSelectionChange = () => {},
  ...props 
}) {
  const [thead, tbody] = children || [];
  let { props: { children: rowsHead } } = thead;
  let { props: { children: rows } } = tbody;
  
  if(rows && _.isArray(rows[0])) {
    rows = rows.flat().filter(v => v)
  }

  let firstHeaderColumns = rowsHead;
  let resOfRows = null;
  if(_.isArray(firstHeaderColumns)) {    
    firstHeaderColumns = firstHeaderColumns[0];
    resOfRows = rowsHead.slice(1);
  }

  const selection = _.keyBy(selected);

  const toggleSel = (key, index, e) => {
    if(e.shiftKey && selected.length) {
      let indexes = _.map(selected, k => _.findIndex(rows, {key: k}));
      let min = _.min(indexes);
      let max = _.max(indexes);
      let newKeys = (index >= max ? _.range(max+1, index+1) : _.range(Math.min(min, index), max)).map(i => rows[i].key);
      onSelectionChange(_.uniq(selected.concat(newKeys)));
    } else if(e.ctrlKey || e.metaKey || additiveSelection) {
      if (selection[key]) {
        onSelectionChange(_.without(selected, key));
      } else {
        onSelectionChange([...selected, key]);
      }
    } else {
      if(selection[key]) {
        onSelectionChange(_.without(selected, key));
      } else {
        onSelectionChange([key]);
      }
    }
  };

  const toggleSelectAll = () => {
    if(selected.length > 0 || selected.length === rows.length) {
      onSelectionChange([]);
    } else {
      onSelectionChange(_.map(rows, 'key'));
    }
  };

  // Selection button for header
  let selectionButton = <IconButton icon={'check_box_outline_blank'} level={'secondary'} onClick={toggleSelectAll}/>;
  if (selected.length > 0) {
    if (selected.length === rows.length) {
      selectionButton = <IconButton icon={'check_box'} level={'primary'} onClick={toggleSelectAll}/>;
    } else {
      selectionButton = <IconButton icon={'indeterminate_check_box'} level={'primary'} onClick={toggleSelectAll}/>;
    }
  }

  
  return (
    <table className={`${className} table table-sm`} {...props}>
      <thead>
        <tr {... firstHeaderColumns.props}>
          <th className="p-0">
            {selectionButton}
          </th>
          {firstHeaderColumns.props.children}
        </tr>
        {resOfRows}
      </thead>
      <tbody>
        {_.map(rows, (row, i) => {
          if (!row) return null;
          
          const { key, props: { children, className: rowClassName, ...rowProps } = {} } = row;
          const isSelected = selection[key];
          
          return (
            <tr 
              key={key} 
              {...rowProps} 
              className={`${rowClassName || ''} ${isSelected ? 'row-highlight' : ''}`}
            >
              <td className="p-0" style={{width: '1px', whiteSpace: 'nowrap'}}>
                <IconButton 
                  icon={isSelected ? 'check_box' : 'check_box_outline_blank'} 
                  level={isSelected ? 'primary' : 'secondary'} 
                  className='py-0'
                  onClick={(e) => toggleSel(key, i, e)}
                />
              </td>
              {children}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
} 